import { AuthLoginResponseService } from "../../services/auth/AuthenticationServices.type";
import { SET_TOKEN } from "./actionTypes";

export const setToken = (tokens: AuthLoginResponseService) => ({
  type: SET_TOKEN,
  payload: tokens,
});
